import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomePage.vue';
import FreeProduct from '../views/website/FreeProduct';
import AllList from "../views/website/AllList";
import TestPage from "../views/website/TestPage";
import SignIn from "../views/website/SignIn";
import ClaimPrize from "../views/review-card/ClaimPrize";
import ClaimHistory from "../views/review-card/ClaimHistory";
import ClaimDetail from "@/views/review-card/ClaimDetail";


const routes = [
    {
        path: '/sign-in',
        name: 'SignIn',
        component: SignIn,
    },
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/free-product',
        name: 'FreeProduct',
        component: FreeProduct,
    },
    {
        path: '/all-list',
        name: 'AllList',
        component: AllList,
    },
    {
        path: '/test-page',
        name: 'TestPage',
        component: TestPage,
    },


    {
        path: '/claim-prize',
        name: 'ClaimPrize',
        component: ClaimPrize,
        meta: { title: 'Claim Prize' }
    },
    {
        path: '/claim-history',
        name: 'ClaimHistory',
        component: ClaimHistory,
        meta: { title: 'Claim History' }
    },
    {
        path: '/claim-detail/:id',
        name: 'ClaimDetail',
        component: ClaimDetail,
        meta: { title: 'Claim Detail' }
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});


export default router;
